import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

@Component({ name: "ActivationSecretCourses" })
export default class ActivationSecretCourses extends Vue {
    public localizer: any = Localizer;
    public isLoading: boolean = false;
    public isSuccess: boolean = false;
    public isCompleted: boolean = true;
    public formData: any = {};
    public validationErrors: any[] = [];

    get isSecretCourseSubscribeVisible() {
        return this.$store.getters["myTrainingStore/isSecretCourseSubscribeVisible"];
    }

    get secretCourseCode() {
        return this.$store.getters["myTrainingStore/secretCourseCode"];
    }

    get routes() {
        return (<any>window).App.routes;
    }

    @Watch("isSecretCourseSubscribeVisible") isSecretCourseSubscribeVisibleUpdate(newValue: boolean) {
        if (newValue) {
            document.body.classList.add("overflow");
            (<any>this).$refs.activationCoursesModal.classList.add("show");
            if (this.secretCourseCode) {
                this.formData.activationCode = this.secretCourseCode;
            }
        } else {
            document.body.classList.remove("overflow");
            (<any>this).$refs.activationCoursesModal.classList.remove("show");
        }
    }

    public close() {
        this.validationErrors = [];
        this.formData = {};
        this.$store.commit("myTrainingStore/setSecretCourseSubscribeVisible", false);
    }

    public async submitForm() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoading = true;
        this.isCompleted = true;

        try {
            const restult = (await Axios.post(this.routes.MyBremboPartsTraining_ActivateSecretCourse, this.formData)).data;

            GTagHelper.sendEvent("form_submit", "course_subscribe");
            this.isSuccess = true;

            window.location.href = restult.redirectUrl;
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);

                if (this.validationErrors.find(x => x.name === "Profile")) {
                    this.isCompleted = false;
                }
            }
        }

        this.isLoading = false;
    }

    public isValidationError(controlName: string): boolean {
        return FormHelper.isControlValidationError(controlName, this.validationErrors);
    }
};